export default function PrivacyPage() {
  return (
    <div className="static-page">
      <h2>Privacy Policy</h2>
      <p>
        TaskManager App respects your privacy. We collect only the data necessary to provide task tracking, reminders, and account management. This includes your email, task details, and login credentials.
      </p>
      <p>
        Your data is stored securely and never sold to third parties. Reminder emails are sent only to the address you provide. You can delete your account and associated data at any time.
      </p>
      <p>
        We use cookies to enhance your experience. By continuing to use the app, you consent to our data practices.
      </p>
    </div>
  );
}